/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Kembali',
      changePassword: 'Tukar',
      copiedVaultId: 'Disalin!',
      copyVaultID: 'Salin ID Vault',
      create: 'Cipta',
      next: 'Seterusnya',
      notSure: 'Saya tidak pasti',
      signUp: 'Daftar',
      submit: 'Serah',
      updatePassword: 'Kemaskini kata laluan',
    },
    Errors: {
      createReportFailed: 'Gagal mencipta laporan.',
    },
    ReportStatus: {
      CLOSED: 'Ditutup',
      INVESTIGATING: 'Menyiasat',
      NEW: 'Diserahkan',
      READ: 'Baca',
    },
    general: {
      navbar: {
        caseSettings: 'Tetapan kes',
        changePassword: 'Tukar kata laluan',
        logOut: 'Log keluar',
        notifications: 'Pemberitahuan',
        notificationsDrawer: {
          appFileScanFailed: 'Fail telah gagal pemeriksaan keselamatan',
          appReportMatch: 'Rekod GoTogether anda telah dipadankan',
          appReportReassigned: 'Pengurus kes baru telah ditugaskan',
          case: 'Kes',
          caseAssigned: 'Kes telah diberikan kepada anda',
          caseImporterJobCompleted: {
            PartialSuccess: 'Impot kes anda telah selesai dengan kesilapan',
            failure: 'Import kes anda gagal',
            success: 'Kes import anda telah berjaya dilakukan',
          },
          caseLinked: 'Kes yang dihubungkan',
          caseTeamInvite: 'Ditambahkan ke kes',
          caseUnlinked: 'Kes tak disambungkan',
          dataSanitisation: 'Butiran laporan dikemaskini',
          emptyDescription: 'Semak semula kemudian untuk notifikasi baru',
          emptyTitle: 'Anda telah mengikuti sepenuhnya',
          importId: 'ID Import:',
          learnMore: 'Ketahui lebih lanjut',
          markAllAsRead: 'Tandai semua sebagai telah dibaca',
          newMessage: 'Mesej baru',
          newReport: 'Laporan baru diterima',
          permissionRemoved: 'Dikeluarkan dari kes',
          postSSubmissionFile: 'Fail bukti telah ditambahkan',
          report: 'Laporan',
          reportAssigned: 'Laporan yang ditugaskan kepada anda',
          reportStatusChange: 'Status laporan berubah',
          reporterAnonymised: 'Butiran anda telah di-anonimkan',
          reporterReportSubmitted: {
            subtitle: 'Kami cadangkan anda menyimpan salinan laporan anda',
            title: 'Laporan telah dihantar',
          },
          mitigationPlanReminder: 'Kelulusan pelan mitigasi diperlukan',
          staleCase: 'Kes yang tidak ditindaklanjuti',
        },
        privacyStatement: 'Kenyataan privasi',
        reporter: {
          myReports: 'Laporan saya',
        },
        settings: 'Tetapan',
        technicalSupport: 'Sokongan teknikal',
        title: 'Akaun',
      },
      time: {
        day: 'Hari',
        days: 'Hari',
        hour: 'Jam',
        hours: 'Jam',
        minute: 'Minit',
        minutes: 'Minit',
        second: 'Saat',
        seconds: 'Saat',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Tanpa nama',
        autoTranslate: 'Terjemahan automatik dimatikan secara lalai.',
        backToMessages: 'Kembali ke mesej',
        caseSettings: 'Tetapan kes.',
        changeInProfile:
          'Jika anda ingin menukar tetapan ini, anda boleh melakukannya dalam profil anda ',
        deletedByMessage: 'Dipadam oleh {{author}}',
        deletedMessageLabel: 'Mesej ini telah dipadam',
        description:
          'Apabila terjemahan automatik dihidupkan, semua mesej laporan akan\n          diterjemahkan secara automatik menggunakan AI berdasarkan bahasa lalai\n          yang dipilih pada pelayar anda.',
        descriptionSecondHalf:
          'Versi asal semua mesej sentiasa dikekalkan dan boleh didapati dalam sembang.',
        messagePlaceholder: 'Mula menaip...',
        messageSettings: 'Tetapan mesej.',
        originalMessages: 'Asal',
        showMoreBanner: 'Ketahui lebih lanjut tentang terjemahan automatik',
        titlev2: 'Baca semua mesej dalam bahasa pilihan anda.',
        translatedMessageLabel: 'Mesej yang Diterjemah',
        translatedMessages: 'Diterjemah',
        understood: 'Faham',
      },
      Country: {
        description: 'Di negara manakah anda bertugas?',
        header: 'Di negara manakah anda bertugas?',
        noOptions: 'Tiada negara dijumpai',
        other: 'Lain-lain',
        placeholder: 'Cari negara...',
      },
      CreatePublicReport: {
        createReport: 'Cipta laporan',
        helpPage: 'Pergi ke halaman bantuan kami',
        loginToOpr: 'Log Masuk untuk Menjejaki Laporan',
        or: 'atau',
        passwordPlaceholder: 'Masukkan Kata Laluan',
        phoneNumberLoginFailed:
          'Log masuk gagal, nombor telefon/pin tidak betul',
        phoneNumberPlaceholder: 'Masukkan Nombor Telefon anda',
        phoneNumberTooltip:
          'Masukkan nombor telefon yang anda gunakan untuk menghubungi VaultTalk',
        pinPlaceholder: 'Masukkan Pin',
        reportIntroductionParagraph1:
          'Apabila melaporkan insiden, anda akan ditanya beberapa soalan untuk menyokong anda dalam mendokumenkan pengalaman anda.',
        reportIntroductionParagraph2:
          'Sebelum anda menyerahkannya, anda mempunyai pilihan untuk kekal tanpa nama bagi melindungi privasi anda.',
        reportIntroductionParagraph3:
          'Selepas anda menyerahkannya, anda boleh log masuk pada bila-bila masa untuk melihat kemajuan laporan anda & berbincang dengan pengurus kes.',
        reportIssue: 'Laporkan isu',
        usernameLoginFailed:
          'Log masuk gagal, nama pengguna/kata laluan tidak betul',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Hubungan dengan syarikat diperlukan',
            reportedCategoryRequired: 'Kategori dilaporkan adalah diperlukan',
          },
        },
        vaultId: 'ID Vault',
        vaultIdPlaceholder: 'Masukkan E-mel atau ID Vault anda',
        vaultIdTooltip:
          'Untuk laporan tanpa nama, ID Vault ialah abjad angka. Jika laporan bukan tanpa nama, ID Vault ialah alamat e-mel anda',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Kata Laluan Anda',
        yourPhoneNumber: 'Nombor Telefon Anda',
        yourPin: 'Pin 6 Digit Anda',
        yourVaultId: 'ID Vault Anda',
      },
      CustomHeader: {
        companyLogo: '{{company}} Logo',
        openReporting: 'Buka Pelaporan',
        userSettings: 'Tetapan Pengguna',
      },
      Date: {
        approximateDescription:
          'Adakah anda masih ingat anggaran tarikh kejadian itu berlaku?',
        approximatePlaceholder:
          'Contoh: 6 bulan yang lalu /tahun lepas/November yang lalu',
        cancel: 'batal',
        clear: 'kosongkan',
        description: 'Adakah anda masih ingat tarikh kejadian itu berlaku?',
        header: 'Kejadian itu berlaku pada hari apa?',
        ok: 'ok',
        placeholder: 'Contoh: 21 Jun 2020',
      },
      Description: {
        whatHappened: 'Apakah yang berlaku?',
        whatHappenedPlaceholder: 'Gunakan perkataan anda sendiri...',
        whatHappenedText:
          'Dengan kata-kata anda sendiri, terangkan apa yang berlaku',
      },
      Details: {
        disclaimer:
          'Butiran ini akan didedahkan dengan laporan anda. Jika anda ingin kekal tanpa nama, pastikan ia tidak mengandungi maklumat pengenalan.',
        emailPlaceholder: 'E-mel (pilihan)',
        fullNamePlaceholder: 'Nama Penuh (pilihan)',
        header: 'Butiran anda',
        nonAnonSubtitle:
          'Sila berikan nama atau alamat emel anda. Jika anda ingin menerima notifikasi mengenai laporan ini, tambahkan alamat emel yang sesuai di bawah.',
        nonOptionalEmailPlaceholder: 'E-mel',
        nonOptionalFullNamePlaceholder: 'Nama Penuh',
        subtitle:
          'Jika anda ingin menerima pemberitahuan mengenai laporan ini, tambah alamat e-mel yang sesuai di bawah.',
      },
      Emotion: {
        description:
          'Bagaimana perkara itu mempengaruhi perasaan awak? Apakah kesannya?',
        header: 'Apakah kesannya?',
        placeholder: 'Mula menaip...',
      },
      Evidence: {
        addedHeading: 'Ditambah',
        deletedMessage: 'telah dipadam',
        deletedStatus: 'Dihapus',
        failedToOpenFileMessage: 'Gagal membuka fail. Sila cuba lagi',
        fileStatuses: {
          infectedUpload: 'Ditandai dengan pemeriksaan keselamatan',
          passedUpload: 'Lulus pemeriksaan keselamatan',
          pendingUpload: 'Proses daftar masuk keselamatan sedang berjalan',
          readyForDownload: 'Sedia untuk dimuat turun',
        },
        mobileErrorMessage:
          'Fail yang ditandakan: hantar mesej kepada pengurus kes anda',
        nameHeading: 'Nama',
        statusHeading: 'Status',
        tableTitle: 'Bukti',
        webErrorMessage:
          'Fail yang ditandakan: Jika fail anda telah ditandakan, sila hantar mesej kepada pengurus kes',
      },
      FileUpload: {
        addFiles: 'Tambah fail',
        addMoreFiles: 'Tambah lebih banyak fail',
        confirm: 'Sahkan',
        description:
          'Menambah fail sebagai bukti boleh membantu menyokong kecekapan penyelesaian oleh pengurus kes anda. Sila pertimbangkan kandungan fail (termasuk metadata fail) jika anda ingin kekal tanpa nama, dan menghormati hak individu lain dan undang-undang yang berkenaan.',
        dragDrop: 'Letakkan fail di sini atau',
        errorMessage:
          'Fail gagal kerana ralat rangkaian. Klik di bawah untuk menghantar mesej kepada pengurus kes anda untuk mendapatkan bantuan',
        fileLimit: 'Setiap had saiz fail: 100MB',
        fileUploadLimitText: 'Anda hanya boleh memuat naik 10 fail',
        header: 'Tambah bukti',
        helpArticle: 'artikel bantuan',
        highlighted: 'semak imbas fail',
        information: 'Jenis fail yang disokong',
        moreInformation:
          'Untuk maklumat lanjut, sila lihat <a>artikel bantuan</a> ini',
        postSubmissionErrorMessage:
          "Kami tidak dapat memuat naik fail anda kerana ralat sistem. Sila pilih 'sahkan' sekali lagi.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumen:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Imej:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Teks:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Fail terlalu besar',
          invalidFileType: 'Jenis fail tidak disokong: {{extension}}',
          systemError: 'Ralat sistem',
          tooManyFiles: 'Bilangan maksimum fail ialah {{maxFiles}}',
        },
        uploadFiles: 'Muat naik fail',
      },
      Loading: {
        loading:
          'Sila tunggu sementara kami menyerahkan laporan anda kepada pengurus kes...',
        postSubmissionLoading:
          'Sila tunggu sementara kami menyerahkan fail anda...',
      },
      Location: {
        description: 'Di manakah ia berlaku?',
        header: 'Di manakah ia berlaku?',
        placeholder: 'Contoh: Di pejabat',
      },
      MessageListBox: {
        messageCaseManager: 'Mesej pengurus kes',
        report: 'Laporan {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Terjemahan dinyahdayakan',
        enableTranslationLabelEnabled: 'Terjemahan didayakan',
        enableTranslationsDescription:
          'Dayakan terjemahan automatik dan baca semua mesej laporan dalam bahasa pilihan anda. Bahasa yang diterjemahkan adalah berdasarkan bahasa yang dipilih pada peranti anda.',
        enableTranslationsHeader:
          'Dayakan terjemahan automatik untuk mesej laporan',
        enableTranslationsSubDescriptionv2:
          'Anda boleh menukar antara bahasa yang diterjemahkan dan bahasa asal dalam setiap sembang.',
        updateTranslationFailed: 'Kemas kini terjemahan gagal',
        updateTranslationSuccess: 'Tetapan terjemahan berjaya dikemas kini',
      },
      Password: {
        changePasswordHeader: 'Tukar',
        createNewPassword: 'Sila cipta kata laluan baharu',
        createPasswordHeader: 'Kata Laluan Anda',
        currentPasswordPlaceholder: 'Masukkan kata laluan semasa',
        description:
          'Kata laluan yang sah mestilah sekurang-kurangnya 9 aksara panjang dan termasuk satu huruf besar dan satu nombor',
        enterCurrentPassword: 'Sila masukkan kata laluan semasa anda',
        forgottenPasswordInstructions:
          'Masukkan ID Vault alfanumerik anda (bukan alamat emel anda) dan alamat emel untuk menetapkan semula kata laluan anda.',
        newDescription:
          'Cipta kata laluan yang kukuh untuk memastikan akaun anda selamat. Mula menaip untuk melihat garis panduan di bawah.',
        passwordPlaceholder: 'Cipta kata laluan',
        passwordResetRequestedDescription:
          'Jika ID Vault anda wujud dalam sistem kami, anda akan menerima emel dengan arahan untuk menetapkan semula kata laluan anda.',
        passwordResetRequestedHeader: 'Pautan set semula kata laluan diminta',
        reenterPlaceholder: 'Masukkan kata laluan sekali lagi',
        subtitle:
          'Cipta kata laluan untuk menyerahkan laporan ini dan mengaksesnya pada masa akan datang',
        yourVaultId: 'ID Vault Anda',
        yourVaultIdPlaceholder: 'Masukkan ID Vault anda (cth. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Adakah anda melaporkan orang tertentu atau berbilang orang? Bolehkah anda menamakan atau menerangkannya?',
        header: 'Orang yang terlibat',
        placeholder:
          'Mula menaip dan gunakan koma untuk menambah berbilang nama atau keterangan',
      },
      PoweredByVault: 'Dikuasakan oleh {{company}}',
      PrivacyStatement: 'Kenyataan Privasi Produk',
      PublicMessageList: {
        myMessages: 'Mesej saya',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bukti ditambah kepada laporan sedia ada',
        backToReportId: 'Kembali ke ID laporan: {{reportId}}',
        description:
          'Menambah fail sebagai bukti boleh membantu menyokong keberkesanan penyelesaian oleh pengurus kes anda. Sila pertimbangkan kandungan fail (termasuk metadata fail) jika anda ingin kekal tanpa nama, dan menghormati hak individu lain dan undang-undang yang berkenaan. Untuk maklumat lanjut, sila lihat <a>artikel bantuan</a> ini',
        header: 'Tambah bukti tambahan kepada laporan',
        vaultTalkOpenCaseHeader: 'Tambah bukti kepada laporan anda',
      },
      PublicReport: {
        anonymous: 'Tanpa nama',
        backToReports: 'Kembali ke laporan',
        skipped: 'Dilangkau',
      },
      PublicReportCard: {
        addEvidence: 'Tambah bukti tambahan',
        messageCaseManager: 'Mesej pengurus kes',
        reportId: 'ID Laporan:',
        submitted: 'Diserahkan',
        vaultTalkClosedCaseCTA: 'Lihat Bukti',
        vaultTalkOpenCaseCTA: 'Tambah Bukti',
        viewAdditionalEvidence: 'Lihat bukti tambahan',
        viewReport: 'Lihat Laporan',
      },
      PublicReportsList: {
        reportingSystem: 'Sistem Pelaporan',
      },
      Question: {
        placeholder: 'Mula menaip...',
        question: 'Berikan butiran',
        questionText:
          'Sila kongsi kebimbangan, maklumat terkini atau pertanyaan anda dengan kami',
      },
      Relationship: {
        header: 'Hubungan anda dengan organisasi',
        tellUsAbout:
          'Sila beritahu kami tentang hubungan anda dengan organisasi.',
      },
      ResponsiveNavMenu: {
        messages: 'Mesej saya',
        reports: 'Laporan saya',
      },
      Site: {
        description: 'Di lokasi manakah anda bertugas?',
        header: 'Di lokasi manakah anda bertugas?',
        noOptions: 'Tiada lokasi ditemui',
        other: 'Lain-lain',
        placeholder: 'Cari lokasi...',
      },
      SpamPuzzle: {
        dialog: 'Untuk meneruskan, sila selesaikan teka-teki ini',
      },
      SubmissionTypes: {
        reportIssue: 'Pilih kategori',
        whatType: 'Pilih kategori yang paling tepat menerangkan laporan anda',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{category}}',
        country: '<bold>Negara:</bold> {{country}}',
        dateSubmitted: '<bold>Tarikh diserahkan:</bold> {{date}}',
        recordYourVaultID: 'Ingat maklumat ini untuk log masuk',
        successInformation: 'Maklumat lanjut',
        successMessage:
          'Laporan anda telah diserahkan dan sedia untuk disemak. Sebarang fail yang dilampirkan yang memerlukan perhatian akan ditandakan semasa log masuk. Log masuk di bawah untuk melihat kemas kini laporan dan menghantar mesej kepada pengurus kes anda.',
        successSanitationMessage:
          'Simpan salinan untuk rekod anda, dan jaga ID-Vault anda dengan selamat — anda akan memerlukannya untuk mengakses kemas kini dan menghantar mesej kepada pengurus kes anda.',
        successSanitationTagline:
          'Laporan anda telah dihantar dan disimpan dengan selamat.',
        successThankYou: 'Terima kasih atas laporan anda!',
        viewReport: 'Lihat laporan',
      },
      Time: {
        approximateDescription:
          'Adakah anda masih ingat anggaran masa kejadian itu berlaku?',
        approximatePlaceholder:
          'Contoh: pada waktu pagi, pada waktu tengah hari',
        description: 'Adakah anda masih ingat masa kejadian itu berlaku?',
        header: 'Pukul berapakah ia berlaku?',
        invalidTime: 'Format masa mestilah JJ:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Tukar kata laluan',
        closeDialog: 'Tutup Dialog',
        logout: 'Log keluar',
        messageSettings: 'Tetapan Mesej',
        userSettings: 'Tetapan Pengguna',
      },
      Witnesses: {
        description:
          'Adakah anda memberitahu orang lain atau ada sesiapa melihat kejadian itu?',
        header: 'Ada saksi?',
        placeholder: 'Mula menaip...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Hantar mesej',
        title: 'Mesej Pengurus Kes',
        translationHeader: 'Ketahui lebih lanjut tentang terjemahan automatik',
      },
      ReportCard: {
        addEvidence: 'Tambahkan bukti',
        submissionModeVia: 'melalui {{submissionMode}}',
        viewEvidence: 'Lihat bukti',
      },
      ReportList: {
        yourReports: 'Laporan Anda',
      },
      ReportingActivate: {
        buttonText: 'Teruskan',
        description:
          'Jika organisasi anda telah mendaftarkan anda untuk akaun, kami akan menghantar email kepada anda dengan arahan untuk melengkapkan proses penubuhan.',
        emailInput: 'E-mel',
        header: 'Masukkan e-mel kerja anda',
        successAccount:
          'Jika organisasi anda telah mendaftarkan anda untuk akaun, kami akan menghantar anda email dengan arahan untuk melengkapkan persediaan.',
        successEmail:
          'Jika anda tidak segera melihatnya, sila tunggu beberapa minit dan segarkan kotak masuk emel anda.',
        successHeading: 'Terima kasih',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Tambahkan bukti ke dalam laporan anda',
        descriptionText:
          'Menambah fail sebagai bukti boleh membantu menyokong kecekapan penyelesaian oleh pengurus kes anda. Sila pertimbangkan kandungan fail (termasuk metadata fail) jika anda ingin kekal anonim, dan menghormati hak individu lain dan undang-undang yang berkenaan. Untuk maklumat lanjut, sila lihat <a>artikel bantuan</a> ini.',
        emptyMessage: 'Tiada bukti tambahan dimuat naik',
      },
      ReportingChangePassword: {
        back: 'Belakang',
        description:
          'Cipta kata laluan yang kuat untuk menjaga akaun anda selamat. Mula menaip untuk melihat garis panduan di bawah.',
        errorToast: 'Tidak boleh mencipta kata laluan, token tidak sah.',
        header: 'Tukar Kata Laluan',
        incorrectCurrentPassword:
          'Kata laluan semasa adalah salah. Sila semak dan cuba lagi.',
        invalidToken: 'Token tidak sah',
        passwordUpdated: 'Kata laluan dikemas kini',
        passwordUpdatedDescription:
          'Kata laluan anda telah berjaya dikemaskini. Terima kasih kerana mengambil langkah ini untuk menjaga keamanan data anda!',
        passwordUsedBefore: 'Penggunaan semula kata laluan tidak dibenarkan',
        passwordUsedBeforeDescription:
          'Untuk keselamatan anda, anda tidak boleh mengulangi mana-mana dari enam kata laluan terakhir anda. Sila pilih kata laluan baru dan unik untuk menjaga akaun anda selamat dan cuba lagi.',
        toastDescription:
          'Kata laluan anda telah berjaya dikemaskini. Terima kasih kerana mengambil langkah ini untuk menjaga data anda selamat!',
        toastMessage: 'Kata laluan dikemas kini',
        updatePasswordCTA: 'Kemaskini kata laluan',
      },
      ReportingConnect: {
        cancelButton: 'Batal',
        connectButton: 'Sambung',
        disclaimer:
          'Menyambungkan akaun Slack anda dengan akaun Vault anda memastikan sambungan yang selamat dan peribadi.<br /><br />Dengan menyambungkan, anda boleh melaporkan salah laku atau bertanya soalan secara langsung dalam Slack. Anda sentiasa mempunyai pilihan untuk melaporkan secara anonim selepas menyambung. Privasi dan keselamatan anda adalah keutamaan utama kami.',
        heading:
          ' Platform Vault meminta kebenaran untuk mengakses akaun {{organisationName}} Slack anda ',
        listHeading: 'Apa yang boleh dilakukan oleh Vault?',
        permissionIdentity: {
          extraInfo: 'Vault akan dapat melihat identiti pengguna Slack anda',
          heading: 'Melihat maklumat tentang identiti pengguna',
        },
        permissionNotifications: {
          extraInfo:
            'Vault akan dapat menghantar pemberitahuan kepada akaun Slack anda, berkaitan sebarang kemas kini terhadap laporan atau soalan yang dihantar',
          heading: 'Menghantar pemberitahuan kepada anda',
        },
        permissionOverview: {
          extraInfo:
            'Vault akan memaparkan gambaran keseluruhan semua penyerahan di halaman utama',
          heading: 'Gambaran keseluruhan penyerahan',
        },
        permissionSubmitReport: {
          extraInfo:
            'Ini akan memberikan kebenaran kepada Vault untuk menghantar laporan atau bertanya soalan, terus kepada organisasi anda, daripada Slack',
          heading: 'Serahkan laporan atau soalan bagi pihak anda',
        },
        successfulConnectionDescription:
          'Akaun Vault anda dan akaun Slack kini telah disambungkan. Anda kini boleh menutup tab ini dan kembali ke Slack.',
        successfulConnectionHeading: 'Berjaya disambungkan',
        unsuccessfulConnectionDescription:
          'Sesuatu telah berlaku yang salah. Sila tutup tab ini dan kembali ke Slack untuk mencuba lagi.',
        unsuccessfulConnectionHeading: 'Sambungan gagal',
      },
      ReportingForgotPassword: {
        description:
          'Masukkan alamat emel yang dikaitkan dengan akaun anda, dan kami akan menghantar anda pautan untuk menetapkan semula kata laluan anda.',
        heading: 'Lupa kata laluan',
        invalidTokenError: 'Tidak dapat mencipta kata laluan, token tidak sah.',
        passwordReuseError: 'Penggunaan semula kata laluan tidak dibenarkan',
        passwordReuseErrorDescription:
          'Untuk keselamatan anda, anda tidak boleh menggunakan semula mana-mana daripada enam kata laluan terakhir anda. Sila pilih kata laluan baru dan unik untuk menjaga keselamatan akaun anda dan cuba lagi.',
        sendLink: 'Hantar pautan set semula',
        sendLinkFailure: 'Sesuatu telah berlaku salah',
        sendLinkFailureDescription:
          'Kembali ke <a>Reporter Hub</a> dan cuba lagi. Sekiranya isu ini berterusan, hubungi kami di <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Pautan set semula kata laluan dihantar',
        sendLinkSuccessDescription:
          'Kami telah menghantar pautan set semula kata laluan ke {{email}}',
        updatePasswordSuccess: 'Kata laluan dikemas kini',
        updatePasswordSuccessDescription:
          'Kata laluan anda telah berjaya dikemaskini. Terima kasih kerana mengambil langkah ini untuk menjaga data anda selamat!',
      },
      ReportingLogin: {
        accountFrozen: 'Akaun telah dibekukan',
        accountLocked:
          'Log masuk telah dicuba terlalu banyak kali dengan salah. Akaun ini telah dikunci sehingga 1 jam. Tidak dapat menetapkan semula kata laluan semasa tempoh ini.',
        accountLockedPermanently:
          'Akaun anda telah dikunci. Gunakan tetapan semula kata laluan untuk mendapatkan semula akses atau hubungi pentadbir sistem anda untuk bantuan lanjut.',
        createAccountCTA: 'Daftar untuk akaun',
        currentPassword: 'Kata Laluan Semasa',
        emailLabel: 'Emel Anda',
        forgotPassword: 'Lupa kata laluan anda?',
        loginButton: 'Log masuk',
        newPasswordPlaceholder: 'Kata laluan baharu',
        passwordFailMessage:
          'Kembali ke Aplikasi Vault di Slack dan cuba sekali lagi. Jika isu ini berterusan, hubungi kami di techsupport@vaultplatform.com',
        passwordFailTitle: 'Ada sesuatu yang tidak kena',
        passwordLabel: 'Kata Laluan Anda',
        passwordPlaceholder: 'Masukkan kata laluan anda',
        passwordResetRequired: 'Penetapan semula kata laluan diperlukan',
        passwordSuccessfullySetMessage:
          'Kembali ke Aplikasi Vault di Slack dan sahkan dengan kata laluan baharu anda untuk meneruskan di tempat anda berhenti.',
        passwordSuccessfullySetTitle: 'Kata laluan berjaya ditetapkan',
        reenterPlaceholder: 'Masukkan semula kata laluan',
        title: 'Pemberita Hub',
        tooltip:
          'Jika anda belum pernah menetapkan kata laluan untuk aplikasi Vault, ikuti di sini untuk memulakan. Jika anda lupa kata laluan anda, gunakan pautan "Lupa Kata Laluan" di bawah.',
        usernameLoginFailed:
          'Log masuk gagal, nama pengguna atau kata laluan tidak betul',
      },
      ReportingReset: {
        failureDescription:
          'Kembali ke Aplikasi Vault dalam Slack dan cuba lagi. Jika isu berterusan, hubungi kami di <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Sesuatu yang salah',
        successDescription:
          'Kembali ke Aplikasi Vault di Slack dan sahkan dengan kata laluan baru anda untuk meneruskan di mana anda berhenti sebelum ini',
        successHeading: 'Kata laluan berjaya ditetapkan',
      },
      noReports: {
        description:
          'Semua laporan yang dihantar akan ditunjukkan di sini. Ketahui lebih lanjut tentang cara-cara yang boleh anda gunakan untuk menghantar laporan di',
        descriptionHelpArticle: 'artikel bantuan ini',
        errorDescription:
          'Kami menghadapi kesulitan untuk memuatkan laporan anda. Sila cuba menyegarkan halaman ini.',
        errorDescriptionSecondary:
          'Jika itu tidak berfungsi, sila hubungi kami di',
        errorTitle: '⚠️ Oops, sesuatu telah berlaku salah',
        title: 'Anda belum ada laporan lagi',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Dayakan terjemahan automatik dan baca semua mesej laporan dalam bahasa pilihan anda. Bahasa yang diterjemahkan adalah berdasarkan bahasa yang dipilih pada peranti anda.',
          autoTranslationDescription2:
            'Anda boleh bertukar antara bahasa yang diterjemahkan dan bahasa asal dalam setiap perbualan.',
          autoTranslationTitle:
            'Dayakan terjemahan automatik untuk mesej laporan',
          header: 'Tetapan Mesej',
          subHeader: 'Konfigurasikan bagaimana mesej dipaparkan',
        },
        notificationSettings: {
          emailDescription:
            'Terima notifikasi email untuk kemas kini penting pada laporan anda',
          emailTitle: 'Notifikasi Email',
          header: 'Tetapan Pemberitahuan',
          subHeader: 'Konfigurasikan bagaimana anda menerima pemberitahuan',
        },
        title: 'Tetapan',
        updatedSettingsFailure: 'Gagal untuk mengemas kini tetapan anda',
        updatedSettingsSuccess: 'Berjaya mengemas kini tetapan anda',
      },
    },
    validators: {
      passwordLength: 'Kata laluan mesti sekurang-kurangnya 9 aksara',
      passwordLowercase:
        'Kata laluan mesti mengandungi sekurang-kurangnya 1 huruf kecil',
      passwordMissMatch: 'Medan kata laluan dan pengesahan perlulah sepadan.',
      passwordNumeric:
        'Kata laluan mesti mengandungi sekurang-kurangnya 1 nombor',
      passwordUppercase:
        'Kata laluan mesti mengandungi sekurang-kurangnya 1 huruf besar',
    },
    validatorsNew: {
      passwordLength: 'Antara 10 dan 30 aksara',
      passwordLowercase: 'Sekurang-kurangnya satu huruf kecil',
      passwordMissMatch: 'Kata laluan tidak sepadan',
      passwordNumeric: 'Sekurang-kurangnya satu nombor',
      passwordSpecialCharacter: 'Sekurang-kurangnya satu aksara istimewa',
      passwordUppercase: 'Sekurang-kurangnya satu huruf besar',
    },
  },
};

export default translations;
